(() => {
  const root = document.querySelector('.feb-manager');
  if (!root) return;
  const base = root.dataset.proxyBase;
  const $ = id => document.getElementById(id);
  const loginBox = $('feb-manager-login'), appBox = $('feb-manager-app');
  const loginMessage = $('feb-manager-login-message'), orderMessage = $('feb-order-message');
  const form = $('feb-order-form');
  let orders = [];

  async function api(path, options={}) {
    const res = await fetch(`${base}${path}`, {
      credentials:'same-origin',
      headers:{'Content-Type':'application/json', ...(options.headers||{})},
      ...options
    });
    const data = await res.json().catch(()=>({}));
    if (!res.ok) throw new Error(data.error || 'Request failed');
    return data;
  }
  function message(el,text,success=false){el.textContent=text;el.classList.toggle('is-success',success);}
  function resetForm(){
    form.reset(); $('feb-record-id').value=''; $('feb-order-form-title').textContent='Add order';
    $('feb-status').value='order_confirmed';
  }
  function fillForm(o){
    $('feb-record-id').value=o.id; $('feb-order-id').value=o.orderId;
    $('feb-customer').value=o.customerName||''; $('feb-mobile').value=o.mobile||'';
    $('feb-product').value=o.product||''; $('feb-order-date').value=o.orderDate||'';
    $('feb-delivery-date').value=o.expectedDelivery||''; $('feb-status').value=o.status;
    $('feb-note').value=o.note||''; $('feb-order-form-title').textContent='Edit order '+o.orderId;
    window.scrollTo({top:form.getBoundingClientRect().top+window.scrollY-100,behavior:'smooth'});
  }
  function renderOrders(){
    const q=$('feb-order-search').value.toLowerCase();
    const shown=orders.filter(o=>(o.orderId+' '+(o.customerName||'')).toLowerCase().includes(q));
    $('feb-orders-list').innerHTML=shown.length?shown.map(o=>`
      <div class="feb-order-row">
        <div><strong>${safe(o.orderId)} · ${safe(o.customerName||'Customer')}</strong>
        <p>${safe(o.product||'Furniture order')} · ${safe(o.statusLabel)}</p>
        <p>Expected: ${safe(o.expectedDelivery||'Not set')}</p></div>
        <div class="feb-order-row__actions">
          <button class="feb-btn feb-btn--outline" data-edit="${safe(o.id)}" type="button">Edit</button>
          <button class="feb-btn feb-btn--outline" data-delete="${safe(o.id)}" type="button">Delete</button>
        </div>
      </div>`).join(''):'<p>No orders found.</p>';
  }
  function safe(v){return String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
  async function loadOrders(){const d=await api('/admin/orders');orders=d.orders;renderOrders();}
  async function checkSession(){
    try{await api('/admin/session');loginBox.hidden=true;appBox.hidden=false;await loadOrders();}
    catch{loginBox.hidden=false;appBox.hidden=true;}
  }
  $('feb-manager-login-form').addEventListener('submit',async e=>{
    e.preventDefault();message(loginMessage,'Signing in…');
    try{await api('/admin/login',{method:'POST',body:JSON.stringify({password:$('feb-manager-password').value})});loginMessage.textContent='';loginBox.hidden=true;appBox.hidden=false;await loadOrders();}
    catch(err){message(loginMessage,err.message);}
  });
  $('feb-manager-logout').addEventListener('click',async()=>{try{await api('/admin/logout',{method:'POST',body:'{}'});}catch{}appBox.hidden=true;loginBox.hidden=false;});
  form.addEventListener('submit',async e=>{
    e.preventDefault();message(orderMessage,'Saving…');
    const payload={orderId:$('feb-order-id').value.trim(),customerName:$('feb-customer').value.trim(),mobile:$('feb-mobile').value.trim(),product:$('feb-product').value.trim(),orderDate:$('feb-order-date').value,expectedDelivery:$('feb-delivery-date').value,status:$('feb-status').value,note:$('feb-note').value.trim()};
    try{
      const id=$('feb-record-id').value;
      await api(id?`/admin/orders/${encodeURIComponent(id)}`:'/admin/orders',{method:id?'PUT':'POST',body:JSON.stringify(payload)});
      message(orderMessage,'Order saved successfully.',true);resetForm();await loadOrders();
    }catch(err){message(orderMessage,err.message);}
  });
  $('feb-reset-form').addEventListener('click',()=>{resetForm();message(orderMessage,'');});
  $('feb-order-search').addEventListener('input',renderOrders);
  $('feb-orders-list').addEventListener('click',async e=>{
    const edit=e.target.closest('[data-edit]'), del=e.target.closest('[data-delete]');
    if(edit){const o=orders.find(x=>x.id===edit.dataset.edit);if(o)fillForm(o);}
    if(del&&confirm('Delete this tracking record?')){try{await api(`/admin/orders/${encodeURIComponent(del.dataset.delete)}`,{method:'DELETE'});await loadOrders();}catch(err){alert(err.message);}}
  });
  checkSession();
})();
